import {
    AD_UNIT,
    AVG_CPM,
    AVG_RPM, BID_RATE,
    GEO, GROSS_REVENUE, INITIAL_IMPRESSIONS,
    PAGE_VIEWS,
    PRODUCT_TYPE, REFRESH_IMPRESSIONS,
    TOTAL_IMPRESSIONS, VIEWABILITY, WIN_RATE,
    INTEGRATION, BID_REQUEST, BID_RESPONSE,
    WINNING_BID, GROSS_REVENUE_WITHOUT_DISCREPANCY,
    REVENUE_TYPE, AD_REQUEST, VIDEO_VIEWED, VIDEO_START,
    VIDEO_Q1, VIDEO_Q2, VIDEO_Q3, VIDEO_COMPLETE, VIDEO_CLICK, SITE
} from "../../../monetization/consts";

export const REPORT_TYPE = 'Monetization';

// general
export const ACCOUNT_UUID = 'accountUUID';
export const REPORT_UUID = 'reportUUID';
export const NEW_REPORT_UUID = 'newReport'
export const REPORT_NAME = 'name';
export const REPORT_NAME_LENGTH = '191';
export const REPORT_CREATED = 'createdAt';
export const REPORT_RANGE = 'dateRange';
export const REPORT_FROM = 'from';
export const REPORT_TO = 'to';
export const FILTERS = 'filters';
export const PERIOD_AGG = 'periodAggregationType';

// dimensions
export const DIMENSIONS = 'dimensions';
export const METRICS = 'metrics';
export const STANDARD_DIMENSION = 'standardDimension';
export const INTERVAL_DIMENSION = 'intervalDimension';
export const DIMENSION_TYPES = [STANDARD_DIMENSION , INTERVAL_DIMENSION];

export const PREBID_METRICS = 'prebidMetrics';
export const INTERNAL_DIMENSIONS = 'internalDimensions';
export const INTERNAL_METRICS = 'internalMetrics';
export const MONETIZATION_METRICS = 'monetizationMetrics';
export const PREBID_VIDEO_METRICS = 'prebidVideoMetrics';
export const PREBID_MONETIZATION_METRICS = 'prebidMonetizationMetrics';
export const PERFORMANCE_METRICS = 'performanceMetrics';
export const METRICS_TYPES = [MONETIZATION_METRICS,PREBID_MONETIZATION_METRICS,PREBID_VIDEO_METRICS,PERFORMANCE_METRICS];

// filters
export const SITES = 'SITE';
export const DEVICES = 'DEVICE';
export const COUNTRIES = 'GEO';

// schedule
// schedule
export const IS_SCHEDULED = 'isScheduled';
export const SCHEDULE = 'schedule';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const FREQUENCY = 'frequency';
export const FORMAT = 'format';
export const RECIPIENTS = 'recipientEmails';
export const FREQUENCY_MESSAGE_MONTHLY = `Monthly reports will be sent on the first day of the month, and set the period to “last month” by default.`
// To be used for something like: Report will be sent every [Saturday] at 5:30pm EST till [2022-08-29].
export const FREQUENCY_MESSAGE_WEEKLY = [`Report will be sent every`, `at 5:30pm EST till`]
// To be used for something like: Report will be sent daily at 5:30pm EST till [2022-08-29].
export const FREQUENCY_MESSAGE_DAILY = `Report will be sent daily at 5:30pm EST till`

// SortableList groupings
// period aggregation
export const DATE = 'DATE'  // dimensions
export const YEAR = 'YEAR'  // dimensions
export const MONTH = 'MONTH'  // dimensions
export const WEEK = 'WEEK'  // dimensions
export const QUARTER = 'QUARTER'  // dimensions

export const NET_REVENUE = 'NET_REVENUE'  // metrics

// table
export const NOT_AVAILABLE = 'N/A'

// form columns
export const FORM_HEADERS = [
    {key: "name", title: "Name"},
    {key: "frequency", title: "Delivery Schedule"},
    {key: "endDate", title: "End Date"},
    {key: "recipients", title: "Recipients"},
    {key: "creationDate", title: "Creation Date"},
    {key: "actions", title: ""},
];

// available date range shortcuts: YESTERDAY, LAST_SEVEN_DAYS, LAST_THIRTY_DAYS, LAST_WEEK, LAST_MONTH, CUSTOM
// form initial values, used for create new
export const DEFAULT_FORM_VALUES = {
    isOpened: true,
    reportUUID: 'newReport',
    accountUUID: null,
    createdAt: Date.now(),
    name: null,
    dateRange: "CUSTOM",
    from: null,
    to: null,
    dimensions: [DATE],
    metrics: [NET_REVENUE],
    standardDimension:[],
    intervalDimension:[DATE],
    prebidMonetizationMetrics: [],
    monetizationMetrics: [NET_REVENUE],
    performanceMetrics: [],
    prebidVideoMetrics: [],
    filters: {},
    //"schedule":{ "frequency":"ONCE", "format":"CSV" } === disabled
    isScheduled: false,
    schedule: {
        startDate: null,
        endDate: null,
        frequency: "ONCE",
        format: "CSV",
        recipientEmails: []
    }
}

export const DEFAULT_DIMENSION_STATE = {
    dimensions: [DATE],
    standardDimension:[],
    intervalDimension:[DATE],
}

export const DEFAULT_METRIC_STATE = {
    metrics: [NET_REVENUE],
    prebidMonetizationMetrics: [],
    monetizationMetrics: [NET_REVENUE],
    performanceMetrics: [],
    prebidVideoMetrics: [],
}

export const DEFAULT_SCHEDULE = {
    startDate: null,
    endDate: null,
    frequency: "ONCE",
    format: "CSV",
    recipientEmails: []
}

// period agg
export const PERIOD_AGG_OPTIONS = [
    {"name": "Daily", "value": "DAILY"},
    {"name": "Weekly", "value": "WEEKLY"},
    {"name": "Monthly", "value": "MONTHLY"},
    {"name": "Quarterly", "value": "QUARTERLY"},
]


// sortable list
// dimentions
export const DIMENSIONS_OPTIONS = [
    {value: YEAR, text: 'Year',type:INTERVAL_DIMENSION,isInternal:false},
    {value: QUARTER, text: 'Quarter',type:INTERVAL_DIMENSION,isInternal:false},
    {value: MONTH, text: 'Month',type:INTERVAL_DIMENSION,isInternal:false},
    {value: WEEK, text: 'Week',type:INTERVAL_DIMENSION,isInternal:false},
    {value: DATE, text: 'Day', type:INTERVAL_DIMENSION,isInternal:false},
    {value: PRODUCT_TYPE, text: 'Product', type:STANDARD_DIMENSION,isInternal:false},
    {value: SITE, text: 'Domain/App', type:STANDARD_DIMENSION,isInternal:false},
    {value: DEVICES, text: 'Device',type:STANDARD_DIMENSION,isInternal:false},
    {value: GEO, text: 'Country',type:STANDARD_DIMENSION,isInternal:false},
    {value: AD_UNIT, text: 'Ad Unit',type:STANDARD_DIMENSION,isInternal:false},
    {value: REVENUE_TYPE, text: 'Revenue Type',type:STANDARD_DIMENSION,isInternal:false},
    {value: INTEGRATION, text: 'Integration',type:STANDARD_DIMENSION, isInternal:true}

];

export const NO_PAGEVIEW_DIMENSION_SUPPORT = [PRODUCT_TYPE, AD_UNIT, REVENUE_TYPE, INTEGRATION]

export const DISABLE_DIMENSION_AND_METRIC_SUPPORT = [PRODUCT_TYPE]

// monetization metrics
// available: GROSS_REVENUE, AVG_RPM, AVG_CPM, AVG_AD_VIEWABILITY, NET_REVENUE, PAGE_VIEWS, INITIAL_IMPRESSIONS, REFRESH_IMPRESSIONS, IMPRESSIONS
export const METRICS_OPTIONS = [
    {value: NET_REVENUE, text: 'Publisher Revenue'},
    {value: AVG_RPM, text: 'Avg Page RPM'},
    {value: PAGE_VIEWS, text: 'Monetizable Page Views'},
    {value: VIEWABILITY, text: 'Avg Ad Viewabilty'}
];

// internal only metrics


export const PREBID_METRICS_OPTIONS = [
    {value: BID_RATE, text: 'Bid Rate'},
    {value: WIN_RATE, text: 'Win Rate'},

];

export const NO_PAGEVIEW_METRIC_SUPPORT = [AVG_RPM, PAGE_VIEWS]

export const PRODUCT_METRIC_SUPPORT = [BID_RATE, WIN_RATE, BID_REQUEST, BID_RESPONSE, INTEGRATION, WINNING_BID, GROSS_REVENUE_WITHOUT_DISCREPANCY,
    VIDEO_VIEWED, VIDEO_START, VIDEO_Q1, VIDEO_Q2, VIDEO_Q3, VIDEO_COMPLETE, VIDEO_CLICK]

// internal only dimensions
export const INTERNAL_DIMENSIONS_OPTIONS = [
    {value: INTEGRATION, text: 'Integration'}
];

// internal only metrics
export const INTERNAL_METRICS_OPTIONS = [
    {value: GROSS_REVENUE, text: 'Gross revenue'},
    {value: INITIAL_IMPRESSIONS, text: 'Initial loads'},
    {value: REFRESH_IMPRESSIONS, text: 'Refresh'},
    {value: AVG_CPM, text: 'Avg CPM'},
    {value: TOTAL_IMPRESSIONS, text: 'Impressions'},
    {value: WINNING_BID, text: 'Winning Bid'},
    {value: GROSS_REVENUE_WITHOUT_DISCREPANCY, text: 'Gross Revenue w/o Discrepancy'},
    {value: BID_REQUEST, text: 'Bid Request'},
    {value: BID_RESPONSE, text: 'Bid Response'},
    {value: AD_REQUEST, text: 'Ad Request'},
    {value: VIDEO_VIEWED, text: 'Video Viewed'},
    {value: VIDEO_START, text: 'Video Start'},
    {value: VIDEO_Q1, text: 'Video Q1'},
    {value: VIDEO_Q2, text: 'Video Q2'},
    {value: VIDEO_Q3, text: 'Video Q3'},
    {value: VIDEO_COMPLETE, text: 'Video Complete'},
    {value: VIDEO_CLICK, text: 'Video Click'}
];

// delivery settings
// available: WEEKLY, MONTHLY, ONCE, DAILY
export const FREQUENCY_OPTIONS = [
    {value: 'DAILY', title: 'Daily'},
    {value: 'WEEKLY', title: 'Weekly'},
    {value: 'MONTHLY', title: 'Monthly'}
];

export const FORMAT_OPTIONS = [
    {value: 'CSV', title: 'CSV'},
    {value: 'XLSX', title: 'Excel'}
];

// error texts
export const RECIPIENTS_ERROR_TEXT = 'Please select at least one recipient';
export const TOO_MANY_RECIPIENTS_ERROR_TEXT = 'Recipients limit is 10';
export const EMAIL_ERROR_TEXT = 'Wrong email format, please enter valid email address';
export const EMAIL_DUPLICATED_ERROR_TEXT = 'Email already included in the list';
export const REPORT_NAME_ERROR_TEXT = 'Report name is required';
export const REPORT_NAME_DUPLICATED_ERROR_TEXT = 'Report name already exists';

// Button texts
export const CANCEL_TITLE = 'Cancel';

export const SAVE_TITLE = 'Save & Close';

export const DATE_OPTIONS_REPORT_BUILDER = [
    {name: 'Yesterday', value: 'YESTERDAY'},
    {name: 'Last 7 Days', value: 'LAST_SEVEN_DAYS'},
    {name: 'Last 30 Days', value: 'LAST_THIRTY_DAYS'},
    {name: 'Last week', value: 'LAST_WEEK'},
    {name: 'Last month', value: 'LAST_MONTH'},
    {name: 'Custom', value: 'CUSTOM'},
];

// metrics
export const TOTAL_METRICS_OPTIONS = [
    {value: NET_REVENUE, text: 'Revenue',type: MONETIZATION_METRICS, isInternal: false},
    {value: AVG_RPM, text: 'Avg RPM', type: MONETIZATION_METRICS, isInternal: false},
    {value: PAGE_VIEWS, text: 'Monetizable Page Views', type: MONETIZATION_METRICS, isInternal: false},
    {value: VIEWABILITY, text: 'Avg Ad Viewabilty',type: MONETIZATION_METRICS, isInternal: false},
    {value: GROSS_REVENUE, text: 'Gross revenue',type: MONETIZATION_METRICS, isInternal: true},
    {value: AD_REQUEST, text: 'Total Ad Requests' , type: PERFORMANCE_METRICS, isInternal: false},
    {value: TOTAL_IMPRESSIONS, text: 'Impressions' , type: PERFORMANCE_METRICS, isInternal: false},
    {value: AVG_CPM, text: 'Avg CPM',type: PERFORMANCE_METRICS, isInternal: false},
    {value: INITIAL_IMPRESSIONS, text: 'Initial loads',type: PERFORMANCE_METRICS, isInternal: true},
    {value: REFRESH_IMPRESSIONS, text: 'Refresh',type: PERFORMANCE_METRICS, isInternal: true},
    {value: WINNING_BID, text: 'Winning Bids', type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: BID_RATE, text: 'Bid Rate',type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: WIN_RATE, text: 'Win Rate',type: PREBID_MONETIZATION_METRICS, isInternal: false},
    {value: GROSS_REVENUE_WITHOUT_DISCREPANCY, text: 'Gross Revenue w/o Discrepancy',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: BID_REQUEST, text: 'Bid Request',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: BID_RESPONSE, text: 'Bid Response',type: PREBID_MONETIZATION_METRICS, isInternal: true},
    {value: VIDEO_VIEWED, text: 'Video Viewed',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_START, text: 'Video Start',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q1, text: 'Video 25% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q2, text: 'Video 50% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_Q3, text: 'Video 75% Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_COMPLETE, text: 'Video Complete',type: PREBID_VIDEO_METRICS, isInternal: true},
    {value: VIDEO_CLICK, text: 'Video Click',type: PREBID_VIDEO_METRICS, isInternal: true}
]
